"use client";
import { useDrawer } from "@/utils/DrawerProvider";
import { UserSession } from "@/utils/types";
import Script from "next/script";
import { useEffect } from "react";
import api from "../lib/api";

export function ClientOnlyScript({ session }: { session: UserSession }) {
  const { isAnyDrawerOpen, closeLastDrawer } = useDrawer();

  useEffect(() => {
    //@ts-ignore
    window.back = function () {
      console.log("Going back!");
      console.log("isAnyDrawerOpen", isAnyDrawerOpen());

      if (isAnyDrawerOpen()) {
        console.log("drawer open");
        closeLastDrawer();
        return;
      }

      const event_msg = JSON.stringify({ type: "go_back" });
      //@ts-ignore
      if (window["Flutter"]) window["Flutter"].postMessage(event_msg);
    };

    //@ts-ignore
    window.onTokenReceived = async function (token) {
      if (session) {
        await api.users.update(session.id!, { token });
        // fetch(`/api/user/update/${session?.id}`, {
        //   method: "POST",
        //   headers: { "Content-Type": "application/json" },
        //   body: JSON.stringify({ token }),
        // })
        //   .then((response) => response.json())
        //   .then((data) => {
        //     console.log("Token saved:", data);
        //   })
        //   .catch((error) => console.error("Error saving token:", error));
      }
    };
  }, [isAnyDrawerOpen, closeLastDrawer, session]); 

  return (
    <Script id="load-methods" strategy="lazyOnload">
      {`
          // Your script logic doesn't require access to functions here
        `}
    </Script>
  );
}
